// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"894c7c85","232":"b9f835c5","348":"d672329f","391":"cfd5a34e","490":"0d496b03","516":"ad47b136","572":"e2b1b265","667":"90510c9e","787":"7a972b74","826":"f547ba0c"}[chunkId] + ".chunk.js";
};